import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Stack, Typography } from '@packages/fenrir/components';

import styles from './empty.module.css';

type EmptyProps = {
  icon: IconDefinition;
  heading: string;
  message: string;
};

export const Empty: React.FunctionComponent<
  React.PropsWithChildren<EmptyProps>
> = ({ children, icon, heading, message }) => {
  return (
    <Stack
      direction="column"
      height="100%"
      width="100%"
      justifyContent="center"
      alignItems="center"
      padding={2}
      spacing={2}
    >
      <FontAwesomeIcon icon={icon} size="3x" className={styles['empty-icon']} />
      <Typography color="textPrimary" variant="h3" sx={{ textAlign: 'center' }}>
        {heading}
      </Typography>
      <Typography
        color="textSecondary"
        variant="body2"
        sx={{ textAlign: 'center', whiteSpace: 'pre-line' }}
      >
        {message}
      </Typography>
      {children}
    </Stack>
  );
};
